var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReplaceElement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 31.3569L121.833 54.5856C122.328 54.8714 122.633 55.3996 122.633 55.9712V102.429C122.633 103 122.328 103.528 121.833 103.814L81.6 127.043C81.105 127.329 80.4951 127.329 80 127.043L39.7667 103.814C39.2717 103.528 38.9667 103 38.9667 102.429V55.9712C38.9667 55.3996 39.2717 54.8714 39.7667 54.5856L80 31.3569C80.4951 31.0711 81.105 31.0711 81.6 31.3569Z",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.6,
    cy: 57.6,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.2,
    cy: 104,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.6001,
    cy: 126.4,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.6001,
    cy: 32,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 57.6,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.6,
    cy: 105.6,
    r: 12.8,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 56L152.8 40.8",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 124.8L32.0001 110.4",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6001 132V168",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplaceElement);
export default __webpack_public_path__ + "static/media/icon_replace_element.e212cab9fc724817939b776f2a0c846e.svg";
export { ForwardRef as ReactComponent };